import {
  MdEmail,
  MdGroups,
  MdOutlineAutoDelete,
  MdOutlineDomainAdd,
  MdPhoneInTalk,
} from "react-icons/md";
import { MdMarkEmailUnread } from "react-icons/md";
import {
  BsCartCheckFill,
  BsFillSuitHeartFill,
  BsHandbagFill,
} from "react-icons/bs";
import {
  FaCartPlus,
  FaCircleUser,
  FaGift,
  FaHeart,
  FaLocationDot,
  FaReply,
  FaTruck,
  FaTty,
} from "react-icons/fa6";
import { IoHome, IoMenu } from "react-icons/io5";
import {
  AiFillEye,
  AiFillStar,
  AiOutlineDashboard,
  AiOutlineDown,
  AiOutlineLogout,
  AiOutlineStar,
} from "react-icons/ai";
import { IoIosArrowForward } from "react-icons/io";
import { FaPhoneAlt, FaShieldAlt, FaEdit } from "react-icons/fa";
import { TbBrandProducthunt } from "react-icons/tb";
import { RiBillLine } from "react-icons/ri";
import { FcLike } from "react-icons/fc";

const icons = {
  MdPhoneInTalk,
  MdMarkEmailUnread,
  BsHandbagFill,
  FaCircleUser,
  IoHome,
  AiFillStar,
  AiOutlineStar,
  AiFillEye,
  IoMenu,
  BsFillSuitHeartFill,
  IoIosArrowForward,
  MdEmail,
  FaLocationDot,
  FaPhoneAlt,
  AiOutlineLogout,
  FaShieldAlt,
  FaTruck,
  FaGift,
  FaReply,
  FaTty,
  AiOutlineDown,
  AiOutlineDashboard,
  MdGroups,
  TbBrandProducthunt,
  RiBillLine,
  FaEdit,
  MdOutlineAutoDelete,
  MdOutlineDomainAdd,
  FaCartPlus,
  BsCartCheckFill,
  FcLike,
  FaHeart,
};

export default icons;
